import React from 'react';
// @ts-ignore
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import './App.css';
import {ThankYouPage} from "./components/thankyou/ThankYouPage";
import PayPal from "./components/instruments/paypal/PayPal";
import Stripe from "./components/instruments/stripe/Stripe";
import Refresh from "./components/refresh/Refresh";
import {ThankYouPageForRefresh} from "./components/refresh/ThankYouPageForRefresh";
import {CashPage} from "./components/instruments/cash/CashPage";
import {SoldPage} from "./components/thankyou/SoldPage";
import {ThankYouShortPage} from "./components/thankyou/ThankYouShortPage";
import {Price} from "./components/price/Price";
import {Widget} from "./components/widget/Widget";
import {ThankYouPageInvitation} from "./components/confirmation/ThankYouPageInvitation";
import {FlexPrice} from "./components/price/FlexPrice";
import {FaceBookShare} from "./components/common/FaceBookShare";
import {Begin} from "./components/toRemove/Begin";
import {Continue} from "./components/confirmation/Continue";
import {UsedLink} from "./components/thankyou/UsedLink";
import {RedirectToLink} from "./components/common/RedirectToLink";
import {Message} from "./components/thankyou/Message";
import {Unsubscribe} from "./components/thankyou/Unsubscribe";
import {Home} from "./components/homes/Home";
import {LgHome} from "./components/homes/LgHome";
import {ThankYouLead} from "./components/thankyou/ThankYouLead";
import {LgStart} from "./components/lg/LgStart";
import {TildaWidget} from "./components/lg/widgets/TildaWidget";
import {Error} from "./components/common/Error";
import {LeadNew} from "./components/lead/LeadNew";
import {Instruments_new} from "./components/instruments/Instruments_new";
import {Amounts} from "./components/amounts/Amounts";
import {GenericMessage} from "./components/thankyou/GenericMessage";
import {LrrhHome} from "./components/Lrrh/LrrhHome";
import {PaymentDone} from "./components/instruments/cash/PaymentDone";
import {Admin} from "./components/homes/Admin";
import {PriceSelector, Sectors, SectorSelector} from "./components/price/Sectors";
import {ForwardToPackage} from "./components/toRemove/ForwardToPackage";


export function MainRouter() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/tilda/*">
                    <TildaWidget/>
                </Route>
                <Route path="/lgstart">
                    <LgStart/>
                </Route>
                <Route path="/lghome">
                    <LgHome/>
                </Route>
                <Route path="/lrrh">
                    <LrrhHome/>
                </Route>
                <Route path="/admin">
                    <Admin/>
                </Route>
                <Route path="/home">
                    <Home/>
                </Route>
                <Route path="/amt">
                    <Amounts/>
                </Route>
                <Route path="/sectors">
                    <Sectors/>
                </Route>
                <Route path="/lead">
                    <LeadNew/>
                </Route>
                <Route path="/leadgen">
                    <LeadNew/>
                </Route>
                <Route path="/leadok">
                    <ThankYouLead/>
                </Route>
                <Route path="/payment">
                    <Instruments_new/>
                </Route>
                <Route path="/paypal">
                    <PayPal/>
                </Route>
                <Route path="/stripe">
                    <Stripe/>
                </Route>
                <Route path="/thankyouinvitation">
                    <ThankYouPageInvitation/>
                </Route>
                <Route path="/begin">
                    <Begin/>
                </Route>
                <Route path="/forwardtopackage">
                    <ForwardToPackage/>
                </Route>
                <Route path="/ok">
                    <ThankYouPage/>
                </Route>
                <Route path="/cash">
                    <CashPage/>
                </Route>
                <Route path="/sharefacebook">
                    <FaceBookShare/>
                </Route>
                <Route path="/refresh">
                    <Refresh/>
                </Route>
                <Route path="/sold">
                    <SoldPage/>
                </Route>
                <Route path="/message">
                    <Message/>
                </Route>
                <Route path="/genericMessage">
                    <GenericMessage/>
                </Route>
                <Route path="/paymentdone">
                    <PaymentDone/>
                </Route>
                <Route path="/unsubscribe">
                    <Unsubscribe/>
                </Route>
                <Route path="/thankyoushort">
                    <ThankYouShortPage/>
                </Route>
                <Route path="/refreshthankyou">
                    <ThankYouPageForRefresh/>
                </Route>

                <Route path="/widget">
                    <Widget/>
                </Route>
                <Route path="/price">
                    <Price/>
                </Route>
                <Route path="/usedlink">
                    <UsedLink/>
                </Route>
                <Route path="/error">
                    <Error/>
                </Route>
                <Route path="/continue">
                    <Continue/>
                </Route>
                <Route path="/redirect">
                    <RedirectToLink/>
                </Route>
                <Route path="/flexprice">
                    <FlexPrice/>
                </Route>
                <Route path="/">
                </Route>
            </Switch>
        </BrowserRouter>
    )
}
